import { store } from './store.js'

let accessToken = null

export function setAccessToken(token) {
  accessToken = token
}

export function clearAccessToken() {
  accessToken = null
}

export function getAccessToken() {
  return accessToken
}

// Data APIs live under /api; auth endpoints stay at the root.
function resolve(path) {
  return path.startsWith('/auth') ? path : `/api${path}`
}

async function doFetch(method, path, body, headers) {
  return fetch(resolve(path), {
    method,
    headers,
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined
  })
}

async function request(method, path, body) {
  const headers = { 'X-Requested-With': 'XMLHttpRequest' }
  // Only declare a JSON body when one is actually sent — Fastify rejects an
  // empty body when Content-Type is application/json (e.g. bodyless POSTs).
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`

  let res = await doFetch(method, path, body, headers)

  if (res.status === 401 && accessToken) {
    const refreshed = await tryRefresh()
    if (refreshed) {
      headers['Authorization'] = `Bearer ${accessToken}`
      res = await doFetch(method, path, body, headers)
    } else {
      clearAccessToken()
      store.clear()
      window.location.href = '/login'
      return
    }
  }

  return handleResponse(res)
}

async function handleResponse(res) {
  const text = await res.text()
  const data = text ? JSON.parse(text) : null
  if (!res.ok) {
    throw Object.assign(new Error(data?.message || res.statusText), {
      statusCode: res.status,
      code: data?.code
    })
  }
  return data
}

export async function tryRefresh() {
  try {
    // No body is sent (the refresh token comes from the HttpOnly cookie), so we
    // must NOT set Content-Type: application/json — Fastify rejects an empty
    // body with that content-type, which 400s every silent refresh and bounces
    // the user to /login on reload.
    const res = await fetch('/auth/token/refresh', {
      method: 'POST',
      credentials: 'include'
    })
    if (!res.ok) return false
    const data = await res.json()
    setAccessToken(data.accessToken)
    return true
  } catch {
    return false
  }
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  patch: (path, body) => request('PATCH', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path) => request('DELETE', path)
}
